export enum NextFlow {
  CounterOffer = 'COUNTER_OFFER_FLOW',
  DataValidationFlow = 'DATA_VALIDATION_FLOW',
  DisbursementAccountSelection = 'DISBURSEMENT_ACCOUNT_SELECTION',
  FinalDecisionFlow = 'FINAL_DECISION_FLOW',
  IdentityValidation = 'IDENTITY_VALIDATION_FLOW',
  OnBoardingFlow = 'ON_BOARDING_FLOW',
  Redirection = 'REDIRECTION',
  References = 'REFERENCES',
  Signature = 'SIGNATURE',
  Efecty = 'EFECTY',
  Custom = 'CUSTOM_DISPERSION_CHANNEL',
  InternalBureau = 'INTERNAL_BUREAU',
  DispersionMethodSelection = 'DISPERSION_METHOD_SELECTION',
  DocumentIssueOfDateDoesNotMatch = 'DOCUMENT_ISSUE_OF_DATE_DOES_NOT_MATCH',
}
